import React, { useCallback, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { buildSigninUrl, isGuestPostsViewEnabled } from '../newsintelligence/support/openDiscussions';
import { appApiUrl } from '../utils/appApiOrigin';
import { markSessionValid } from '../utils/sessionAuth';
import { AuthRouteSkeleton } from '../layout/ReusableComponent/Skeleton/RouteSkeletons';
import '../layout/ReusableComponent/Skeleton/RouteSkeletons.css';

/**
 * Protects /posts: requires login unless guest browsing is enabled for this deployment.
 */
const PostsGuestRoute = ({ children }) => {
  const guestEnabled = isGuestPostsViewEnabled();
  const [isAuthenticated, setIsAuthenticated] = useState(guestEnabled ? false : null);
  const location = useLocation();

  const validateSession = useCallback(async () => {
    try {
      const response = await axios.post(appApiUrl('/api/validate-session'), {}, { withCredentials: true });
      const ok = response.data.success === true;
      if (ok) markSessionValid();
      setIsAuthenticated(ok);
    } catch {
      setIsAuthenticated(false);
    }
  }, []);

  useEffect(() => {
    validateSession();
  }, [validateSession]);

  if (!guestEnabled && isAuthenticated === null) {
    return <AuthRouteSkeleton />;
  }

  if (!isAuthenticated && !guestEnabled) {
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to={buildSigninUrl({ returnTo })} replace />;
  }

  return children;
};

export default PostsGuestRoute;
